import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/shared/auth/AuthProvider'
import { PERM } from '@/shared/auth/types'
import type { NavBadges } from '@/app/nav'
import { fetchUnreadCount, notificationKeys } from '@/features/notifications/api'
import { fetchSummary, receivableKeys } from './api'

/**
 * The Piutang sidebar's counts.
 *
 * The monitoring page reads the same summary under the same key, so the badge
 * costs no request of its own and always agrees with the "Perlu tindakan"
 * panel. Only work that needs a person counts: failed emails and invoices
 * ready for their first confirmation letter -- not the size of the ledger.
 */
export function usePiutangBadges(): NavBadges {
  const { can } = useAuth()
  const canSee = can(PERM.PIUTANG_INVOICE)

  const summary = useQuery({
    queryKey: receivableKeys.summary,
    queryFn: fetchSummary,
    staleTime: 60_000,
    enabled: canSee,
  })

  const unread = useQuery({
    queryKey: notificationKeys.unread,
    queryFn: fetchUnreadCount,
    staleTime: 30_000,
  })

  const badges: NavBadges = {}
  const waiting = (summary.data?.todo ?? [])
    .filter((item) => item.kind === 'EMAIL_FAILED' || item.kind === 'CONFIRMATION_READY')
    .reduce((total, item) => total + item.count, 0)
  if (canSee && waiting) badges['/piutang'] = { count: waiting, tone: 'attention' }
  const unreadCount = unread.data?.unread
  if (unreadCount) badges['/piutang/notifications'] = { count: unreadCount, tone: 'info' }
  return badges
}
